export function formatSubpages(filterPage) {
  filterPage.subPages.forEach(function(subPage) {
    // Sub Pages:
    //   {..., "filterValues": { "gender": ["men"], ... }, ... }
    // is transformed to
    //   {..., "filterMatches": ["men", ... ], ... }
    //
    subPage.filterMatches = []

    for (let filterId in subPage.filterValues) {
      subPage.filterValues[filterId].forEach(value => subPage.filterMatches.push(value))
    }
  })
  return filterPage
}

export function formatFilters(filterPage) {
  filterPage.filters.forEach(function(filter) {
    // Filters:
    //   {..., "values": { "mens": "For Men", ... }, ... }
    // is transformed to
    //   {..., "values": { "For Men": "mens", ... }, ... }
    //
    const newValues = []

    for (let value in filter.values) {
      let newValue = {}
      newValue[filter.values[value]] = value
      newValues.push(newValue)
      newValues.sort((value1, value2) => Object.keys(value1)[0] - Object.keys(value2)[0])
    }

    filter.values = newValues

    // Filters:
    // type is set to 'checkbox' as default
    //
    filter.type = filter.type || 'checkbox'
  })
  return filterPage
}

export function explodeVariants(filterPageItems) {
  let explodedItems = []
  let id = 0
  filterPageItems.forEach(function(item) {
    item.variants.forEach(variant => {
      id += 1
      const deepCopyItem = JSON.parse(JSON.stringify(item))
      deepCopyItem.id = id
      deepCopyItem.variants = [variant]
      explodedItems.push(deepCopyItem)
    })
  })
  return explodedItems
}

export function formatTags(item) {
  // Items:
  //   {..., "filterValues": { "product": ["shoes"], ...}, ...}
  // is transformed to
  //   {..., "tags": ["shoes"], ...}
  //
  item.tags = []
  for (let filterId in item.filterValues) {
    item.filterValues[filterId].forEach(value => item.tags.push(value))
  }
  return item
}

export function formatVariants(item, filterPage) {
  item.variants.forEach(function(variant) {
    // Item variants:
    //   {..., "filterValues": { "color": ["red"], ...}, ...}
    // is transformed to
    //   {..., "color": ["red"], ...}
    for (let filterId in variant.filterValues) {
      variant[filterId] = variant.filterValues[filterId]
    }

    // Item variants:
    //   {..., "skus": { "productVariantId": 123, "size": "46", stock: 12 }, ...}
    // is transformed to
    //   {..., "size": ["46", ...], ...}
    //
    variant.size = []
    variant.skus.forEach(function(skuData) {
      isNaN(Number(skuData.size))
        ? variant.size.push({ size: skuData.size, stock: skuData.stock, sku: skuData.sku })
        : variant.size.unshift({ size: skuData.size, stock: skuData.stock, sku: skuData.sku })
    })

    // Item variants:
    // it is ensured that there is a property for each variant-level filter
    //
    if (filterPage !== undefined) {
      filterPage.filters.forEach(function(filter) {
        if (filter.level == 'variant') {
          variant[filter.id] = variant[filter.id] || []
        }
      })
    }
  })
  return item
}

export function aggregateSoldItems(item) {
  // Items:
  //   {..., "variants": { "soldItems": 1, ...}, { "soldItems": 3, ...} ...}
  // is transformed to
  //   {..., "soldItems": 4, "variants": { ... }, ...}
  //
  item.soldItems = item.variants.reduce((sum, variant) => sum + variant.soldItems, 0)

  return item
}
